import React, { useState } from 'react';
import { Outlet, useNavigate,useLocation,matchRoutes } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { Link } from 'react-meta-elements';
// 图片
import Logo from 'Src/assets/3.0官网/互牧官网首页/白色LOGO.png';
import downArrow from 'Src/assets/3.0官网/互牧官网首页/down-arrow.png';
import titleLogo from 'Src/assets/3.0官网/互牧官网首页/微信图片_20220125151827.png';

import router from '../router';
import './appLayout.less';

const { Header, Content } = Layout;

const APPLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const toSwitch = (menuItem) => {
    if (menuItem.key === '/product') return;
    if (menuItem.key === '/HMCommunity') {
      window.open('http://bbs.humuyun.com/', '_blank');
      return;
    }
    navigate(menuItem.key);
  };
  // 导航信息
  const [item2] = useState(
    router
      .filter((el) => {
        return el.isTwoRouter;
      })[0]
      .children.map((el) => {
        if (el.copyPath && !el.element) return false;
        if (el.index) {
          return {
            key: el.copyPath,
            label: el.pathName
          };
        } else {
          return {
            key: el.path,
            label: el.pathName
          };
        }
      })
  );
  const [items1] = useState(
    router
      .filter((el) => {
        return el.path === '/';
      })[0]
      .children.map((key) => {
        if (key.index) {
          return {
            key: '/',
            label: key.title
          };
        } else if (key.path === '/product') {
          return {
            key: key.path,
            label: key.title,
            children: item2,
            theme: 'light'
          };
        } else {
          return {
            key: key.path,
            label: key.title
          };
        }
      })
  );

  // 设置菜单栏高亮
  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState([]);
  const [defaultOpenKeys, setDefaultOpenKeys] = useState([]);
  const [isInit, setIsInit] = useState(false);
  React.useEffect(() => {
    // 依赖于location的路由信息
    // 使用matchRoutes方法，第一参数是路由映射表信息，第二个参数是当前路由地址，返回值要么是数组要么是null
    const routes = matchRoutes(router, location.pathname);
    let pathArr = [];
    if (routes) {
      routes.forEach((el) => {
        const path = el.route.path;
        if (path) {
          pathArr = [];
          pathArr.push(path);
        }
      });
    }
    setDefaultSelectedKeys(pathArr);
    setDefaultOpenKeys(pathArr);
    setIsInit(true);
  }, [location.pathname]);
  if (!isInit) return null;

  return (
    <div id="App">
      <Link rel="icon" href={titleLogo} />
      <Layout className="layout">
        <Header>
          <div className="headLogo">
            <img
              onClick={() => {
                navigate('/');
              }}
              src={Logo}
              alt=""
            />
            <img className="down_arrow" src={downArrow} alt="" />
          </div>
          <Menu
            theme="dark"
            mode="horizontal"
            defaultSelectedKeys={defaultSelectedKeys}
            defaultOpenKeys={defaultOpenKeys}
            items={items1}
            onClick={toSwitch}
          ></Menu>
          <div className="register">
            <p>
              <a href="http://www.humuyun.com/#/Registerphone" target="_blank" rel="noreferrer">
                注册
              </a>
            </p>
          </div>
        </Header>
        <Content>
          <Outlet />
        </Content>
      </Layout>
    </div>
  );
};

export default APPLayout;
